// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@ces/App/Components/Common/XngZone";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";

interface CategoryListPageStyles {
    container?: InjectableCss;
    leftSide?: InjectableCss;
    rightSide?: InjectableCss;
}

export const categoryListPageStyles: CategoryListPageStyles = {};
const styles = categoryListPageStyles;

class CategoryListPage extends React.Component<PageProps> {
    render() {
        // XNG-Change: Add zone and structure
        return (
            <Page>
                <StyledWrapper {...styles.container}>
                    <StyledWrapper {...styles.leftSide}>
                        <XngZone contentId={this.props.id} zoneName="Content0" hint="menu" />
                    </StyledWrapper>
                    <StyledWrapper {...styles.rightSide}>
                        <Zone contentId={this.props.id} zoneName="Content" />
                    </StyledWrapper>
                </StyledWrapper>
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: CategoryListPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "CategoryListPage" instead of this constant.
 */
export const CategoryListPageContext = "CategoryListPage";
